//BottomNav.js
import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";

import {
  FaHome,
  FaBook,
  FaStream,
  FaCalendarAlt,
  FaVideo,
  FaUser,
  FaComments,
  FaSignOutAlt,
  FaCamera,
  FaSun,
  FaMoon,
  FaUserCircle,
} from 'react-icons/fa';

const BottomNav = () => {
  const navigate = useNavigate();

  const rotaAtual = window.location.pathname;
  const isDark = document.body.classList.contains('dark-mode');
  const [showSubmenu, setShowSubmenu] = useState(false);

  const temaAtual = localStorage.getItem("tema") || "claro";

  const logout = () => {
    sessionStorage.removeItem("KEY_APP_BGG");
    navigate("/login");
  };

  const toggleTema = () => {
    const novoTema = temaAtual === "dark" ? "claro" : "dark";
    document.body.classList.toggle("dark-mode");
    localStorage.setItem("tema", novoTema);
    setShowSubmenu(false);
  };

  const abrirUpload = () => {
    document.getElementById("avatarFileInput")?.click();
    setShowSubmenu(false);
  };

  const irParaPerfil = () => {
    setShowSubmenu(false);
    navigate("/perfil");
  };

  const links = [
    { href: "/feed", label: "Feed", icon: FaStream },
    { href: "/conteudos", label: "Conteúdos", icon: FaBook },
    { href: "/eventos", label: "Eventos", icon: FaCalendarAlt },
    { href: "#", label: "Perfil", icon: global.gAvatar ? 'avatar' : FaUser, isPerfil: true }
  ];

  return (
    <footer
      className={`main-footer fixed-bottom w-100 m-0 p-0 border-top z-50 ${isDark ? 'bg-dark text-white border-secondary' : 'bg-light text-dark border-light'} bottomnav-shadow`}
      style={{ height: '64px' }}
    >

      {/* Logo central flutuante (ajustado) */}
      <div
        style={{
          position: 'absolute',
          top: '-30px', // 🔼 Subiu mais 10px
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 10
        }}
      >
        <img
          src="https://youevolution.com.br/wp-content/uploads/2022/03/Logo_You_Evolution_Escudo_250x250.png"
          alt="Logo You"
          onClick={() => navigate("/dashboard")} // ⬅️ Adicione isto
          style={{
            width: '55px',
            height: '55px',
            objectFit: 'contain',
            cursor: 'pointer', // 👈 importante
            boxShadow: '0 -4px 10px rgba(0, 0, 0, 0.25)',
            borderRadius: '50%'
          }}
        />


      </div>


      <div className="d-flex justify-content-around align-items-center h-100 position-relative">
        {links.map(({ href, label, icon: Icon, isPerfil }) => {
          const ativo = rotaAtual === href;

          return (
            <div
              key={label}
              className={`text-center flex-fill py-2 ${ativo ? 'text-primary fw-bold' : 'text-muted'}`}
              style={{
                height: '100%',
                fontSize: '13px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'relative',
                cursor: 'pointer',
                color: temaAtual === "dark" ? "#ffffff" : "#111827",
                backgroundColor: temaAtual === "dark" ? "#1f2937" : "#ffffff",
              }}
              onClick={() => {
                if (isPerfil) {
                  setShowSubmenu(!showSubmenu);
                } else {
                  navigate(href);
                }
              }}
            >
              {Icon === 'avatar' ? (
                <img
                  src={global.gAvatar}
                  alt="avatar"
                  style={{
                    width: '28px',
                    height: '28px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    marginBottom: '0px',
                    border: '2px solid #60A5FA'
                  }}
                />
              ) : (
                <Icon className="mb-1" style={{ fontSize: '20px' }} />
              )}
              {label}

              {/* Submenu flutuante */}
              {isPerfil && showSubmenu && (
                <div
                  style={{
                    position: 'absolute',
                    bottom: '70px',
                    backgroundColor: temaAtual === "dark" ? "#1f2937" : "#ffffff",
                    color: temaAtual === "dark" ? "#ffffff" : "#111827",
                    fontSize: '16px',
                    borderRadius: '6px',
                    padding: '6px',
                    left: '-65px',
                    width: '180px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
                    zIndex: 9999
                  }}
                >
                  <button className="dropdown-item d-flex align-items-center" onClick={irParaPerfil}>
                    <FaUserCircle style={{ marginRight: '8px' }} />
                    <span>Meu Perfil</span>
                  </button>

                  <button className="dropdown-item d-flex align-items-center" onClick={abrirUpload}>
                    <FaCamera style={{ marginRight: '8px' }} />
                    <span>Trocar Imagem</span>
                  </button>

                  <button className="dropdown-item d-flex align-items-center" onClick={toggleTema}>
                    {temaAtual === "dark" ? (
                      <FaSun style={{ marginRight: '8px' }} />
                    ) : (
                      <FaMoon style={{ marginRight: '8px' }} />
                    )}
                    <span>{temaAtual === "dark" ? "Tema Claro" : "Tema Escuro"}</span>
                  </button>
                  <button
                    className="dropdown-item d-flex align-items-center"
                    onClick={() => {
                      setShowSubmenu(false);
                      navigate("/mensagens");
                    }}
                  >
                    <FaComments style={{ marginRight: '8px' }} />
                    <span>Mensagens</span>
                  </button>


                  <button className="dropdown-item d-flex align-items-center" onClick={logout}>
                    <FaSignOutAlt style={{ marginRight: '8px' }} />
                    <span>Sair</span>
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Input invisível para upload */}
      <input
        type="file"
        id="avatarFileInput"
        accept="image/*"
        className="d-none"
        onChange={(e) => {
          const file = e.target.files[0];
          if (file) {
            const formData = new FormData();
            formData.append("avatar", file);
            formData.append("id", global.gIdUser);
            fetch("https://api.youevolution.com.br/upload_avatar.php", {
              method: "POST",
              body: formData,
            })
              .then((res) => res.json())
              .then((data) => {
                if (data.avatarUrl) {
                  global.gAvatar = data.avatarUrl;
                  window.location.reload();
                }
              });
          }
        }}
      />
    </footer>
  );
};

export default BottomNav;
